import { createSlice } from "@reduxjs/toolkit";
import { store } from "../../../redux/store";


export const Comment = createSlice({
    name: 'comment',
    initialState: {
        discussion: null,
        openDiscussion: null,

    },
    reducers: {
        setDiscussion: (state, action) => {
            state.discussion = action.payload;

        },
        setOpen: (state, action) => {
            state.openDiscussion = action.payload;
        }
    }
})
export const setDiscussion = (data) => store.dispatch(Comment.actions.setDiscussion(data))
export const setOpenDiscussion = (data) => store.dispatch(Comment.actions.setOpen(data))